import { Box, BoxProps, FileSelector, Icon, LoaderNew, Spacer, Text, TextNew, TextProps } from '@jfs/ui-new'
import { Button } from '../../components/AdminButton'
import {} from '@jfs/ui-new/src/comps/TextNew'
import { isEmptyObject } from '@jfs/utils'
import { useEffect, useState } from 'react'
import XlsxPopulate from 'xlsx-populate'
import { useLazyApiData, useStores } from '../../data/store'
import { MessageTypes } from '../../utils'

const columns = ['Device Id', 'Variant Id']
const { REACT_APP_ENDPOINT = '' } = window?._env_

const OnboardDevices = () => {
  const { setMessage, onBoardDevicesAsync } = useStores((store) => ({
    onBoardDevicesAsync: store.onboarding.onBoardDevicesAsync,
    setMessage: store.message.setMessage,
  }))

  const [fileData, setFileData] = useState({
    name: '',
    wsData: null,
    headers: null,
    values: null,
  })

  const [lazyOnBoardDevicesAsync, onBoardDevicesAsyncHandler] = useLazyApiData(onBoardDevicesAsync)

  const onBoardBulkDevices = () => lazyOnBoardDevicesAsync(fileData.values)

  useEffect(() => {
    console.log('onBoardDevicesAsyncHandler.data', onBoardDevicesAsyncHandler.data)
    if (onBoardDevicesAsyncHandler.state === 'fulfilled') {
      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const data: any = []
        data.push([...fileData.headers, 'Status', 'Response'])
        onBoardDevicesAsyncHandler.data.forEach((element) => {
          data.push(Object.values(element))
        })
        workbook.sheet(0)?.cell('A1').value(data)

        const blob = await workbook.outputAsync({
          type: 'blob',
        })
        var url = window.URL.createObjectURL(blob as Blob)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = `merchantResult_${fileData?.name?.split('.')?.[0]}.xlsx`
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
      setFileData({
        name: '',
        wsData: null,
        headers: null,
        values: null,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onBoardDevicesAsyncHandler.state])

  const [isLoading, setLoading] = useState(false)
  const readExcel = async (file: any, name: string) => {
    if (!file) {
      setFileData({
        ...fileData,
        name,
        wsData: null,
      })
      return
    }
    setLoading(true)
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []
          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                obj[key] = `${String(row._cells[i]?.value() ?? '')?.trim()}`
              }
            }
            !isEmptyObject(obj) && values.push(obj)
          })
          console.log('keys=', keys)
          console.log('values=', values)
          const isExcelInvalid = columns.some((item) => !keys.includes(item))
          if (!isExcelInvalid) {
            console.log({ ...fileData, headers: keys, values: values })
            setFileData({ name, wsData: workbook, headers: keys, values: values })
          } else {
            reject('Invalid File')
          }
        })
        .catch((e) => {
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setFileData({ name: '', wsData: null, headers: null, values: null })
      setMessage(e, MessageTypes.ERROR)
    }
    setLoading(false)
  }

  return (
    <Box {...styles.container}>
      <FileSelector
        innerCompTitle="Please upload onboard device list file"
        innnerCompSubtitle="Browse onboard device list file"
        onFileSelect={readExcel}
        fileType=".xlsx"
        filename={fileData.name}
        isLoading={isLoading}
      />
      <Spacer size={20} />

      <Button
        title={'OnBoard Devices'}
        disabled={!fileData.name || !fileData.wsData}
        isLoading={onBoardDevicesAsyncHandler.state === 'pending'}
        onPress={onBoardBulkDevices}
        children={
          <>
            {onBoardDevicesAsyncHandler.state !== 'pending' && <Text {...styles.textStyle}>Upload</Text>}
            {onBoardDevicesAsyncHandler.state === 'pending' && <LoaderNew color={'WHITE'} />}
          </>
        }
      />
      <Spacer size={20} />
      <a
        href={`${REACT_APP_ENDPOINT}/sample_onboard_devices.xlsx`}
        style={{ textDecoration: 'none' }}
        rel="noopener noreferrer"
        target="_blank">
        <Box flexDirection={'row'} align={'center'}>
          <Icon id={'DOWNLOAD'} color={'PRIMARY'} />
          <Spacer size={8} direction={'horizontal'} />
          <TextNew fontFamily={'jiotype-medium'} fontSize={14} color={'PRIMARY'}>
            {'Sample File'}
          </TextNew>
        </Box>
      </a>
    </Box>
  )
}

const styles = {
  container: {
    flex: 1,
    bg: 'WHITE',
    align: 'center',
    overflow: 'auto',
    padding: 20,
    justifyContent: 'center',
  } as BoxProps,
  textStyle: {
    color: 'WHITE',
    fontSize: 14,
  } as TextProps,
}

export default OnboardDevices
